<template>
  <div class>
    <STable
        ref="tableref"
        :url="url"
        :selection="false"
        :columns="columns"
        :handle="handle"
        :query="query"
        labelWidth="100px"
        cnames="通知接收人"
    ></STable>
  </div>
</template>

<script>
import fieldFilter from "@/utils/fieldFilter.js";
export default {
  name: "gaojingtongzhijilu",
  components: {},
  data() {
    return {
      url: "/alarm/alarmRecord/page",
      columns: [
        {
          label: "终端编码",
          prop: "connectorID"
        },
        {
          label: "终端名称",
          prop: "connectorName"
        },
        {
          label: "归属电站",
          prop: "stationName"
        },
        {
          label: "归属运营商",
          prop: "operatorName"
        },
        // {
        //   label: "品牌",
        //   prop: "equipmentModel"
        // },
        {
          label: "型号",
          prop: "equipmentModel"
        },
        {
          label: "告警原因",
          prop: "alarmName"
        },
        {
          label: "告警时间",
          prop: "createDate"
        },
        {
          label: "通知时间",
          prop: "createDate"
        },
        {
          label: "短信",
          prop: "isSendSMS",
          template:(index,record)=>{
            return record.isSendSMS ? "是" : "否"
          }
        },
      ],

      // 操作栏
      handle: {
        width: 100,
        btns: [
        {
            label: "查看",
            permission: "",
            handle: resp => {
            }
        }
        ]
      },
      query: [
        {
          label: "终端编码",
          prop: "connectorID",
          placeholder: "请输入终端编码",
        },
        {
          label: "终端名称",
          prop: "connectorName",
          placeholder: "请输入终端名称",
        },
        {
          label: "归属电站",
          prop: "stationName",
          placeholder: "请输入归属电站",
        },
        {
          label: "归属运营商",
          prop: "operatorName",
          placeholder: "请输入归属运营商",
        },
        {
          label: "品牌型号",
          prop: "equipmentModel",
          placeholder: "请输入品牌型号",
        },
        {
          label: "告警原因",
          prop: "alarmName",
          placeholder: "请选择告警原因",
          type: "select",
          data: [
            {
              label: "枪线温度告警",
              value: 'CONNECTOR_TEMPERATURE_ALARM'
            },
            {
              label: "充电电压告警",
              value: 'CONNECTOR_VOLTAGE_ALARM'
            },
            {
              label: "充电电流告警",
              value: 'CONNECTOR_ELECTRIC_ALARM'
            },
            {
              label: "输出功率不足告警",
              value: 'CONNECTOR_POWER_ALARM'
            },
            {
              label: "电桩离线告警",
              value: 'CONNECTOR_OFFLINE_ALARM'
            },
            {
              label: "电桩故障告警",
              value: 'CONNECTOR_FAULT_ALARM'
            },
            {
              label: "SOC过充告警",
              value: 'VEHICLE_SOC_ALARM'
            },
            {
              label: "电池电量过充告警",
              value: 'VEHICLE_QUANTITY_ALARM'
            },
            {
              label: "电池温度过高告警",
              value: 'VEHICLE_TEMPERATURE_ALARM'
            },
            {
              label: "用户账户负值告警",
              value: 'USER_BALANCE_ALARM'
            },
          ]
        },
        {
          label: "是否短信通知",
          prop: "isSendSMS",
          placeholder: "请选择通知方式",
          type: "select",
          data: [
            {
              label: "是",
              value: 0
            },
            {
              label:"否",
              value:1
            }
          ]
        },
        {
          label: "通知时间",
          prop: "noticeTime",
          placeholder: "",
          type: "date2"
        },
        {
          label: "告警时间",
          prop: "alarmTime",
          placeholder: "",
          type: "date2"
        },
      ],
    };
  },
  computed: {},
  methods: {},
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/alarmManagement/alarmNotificationRecord.vue